import { StageEntityId as t } from "@perxis-auto/trade-in-sdk/types";
const _ = {
  [t.STAGE_3]: "Рассчитать стоимость",
  [t.STAGE_4]: "Рассчитать стоимость"
};
export {
  _ as FORWARD_BUTTON_TEXT_MAP
};
